module.exports = __webpack_public_path__ + "img/contacts-map.3a355efd.jpg";